import {
    CLASS_EVENTBRITE_FORMAT,
    COMEDY_EVENTBRITE_SUB_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    LGBT_EVENTBRITE_SUB_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PARTY_EVENTBRITE_FORMAT,
    PERFORMANCE_EVENTBRITE_FORMAT,
    PERFORMING_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { DateTranslations, DateTypeEnum } from './interface';

export const DATE_OPTIONS = [
    {
        text: 'default',
        searchValue: DateTypeEnum.CURRENT_FUTURE,
    },
    {
        text: 'Today',
        searchValue: DateTypeEnum.TODAY,
    },
    {
        text: 'Tomorrow',
        searchValue: DateTypeEnum.TOMORROW,
    },
    {
        text: 'This Weekend',
        searchValue: DateTypeEnum.THIS_WEEKEND,
    },
    {
        text: 'This Month',
        searchValue: DateTypeEnum.THIS_MONTH,
    },
];

export const DATE_TRANSLATIONS: DateTranslations = {
    default: gettext('Date'),
    Today: gettext('Today'),
    Tomorrow: gettext('Tomorrow'),
    'This Weekend': gettext('This Weekend'),
    'This Month': gettext('This Month'),
};

export const DATING_TAGS = [
    COMEDY_EVENTBRITE_SUB_CATEGORY,
    CLASS_EVENTBRITE_FORMAT,
    MUSIC_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    PARTY_EVENTBRITE_FORMAT,
    LGBT_EVENTBRITE_SUB_CATEGORY,
    PERFORMANCE_EVENTBRITE_FORMAT,
    PERFORMING_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
];

export const DATING_SUBCATEGORY_URL_PARAM_TO_KEY: { [key: string]: string } = {
    all: 'all',
    today: 'today',
    'this-weekend': 'this-weekend',
    'speed-dating': 'speed-dating',
    music: 'music',
    lgbtqia: 'lgbtqia',
    parties: 'parties',
    comedy: 'comedy',
    'hobbies&crafts': 'hobbies&crafts',
};
